import { render, staticRenderFns } from "./Sheng.vue?vue&type=template&id=2a958545&"
import script from "./Sheng.vue?vue&type=script&lang=js&"
export * from "./Sheng.vue?vue&type=script&lang=js&"
import style0 from "./Sheng.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports